import QuickImportArticlesModal from './QuickImportArticlesModal';

export default QuickImportArticlesModal;
